export enum TIPO_GESTION {
    DOCUMENTOS_AFILIACION_DIRECTA,
    DOCUMENTOS_AFILIACION_COMERCIAL
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/TipoGestion.ts